
  (function () {

    function initLedSlider(section) {

      if (!section || section.dataset.ledSliderInitialized === 'true') {
        return;
      }

      const slider = section.querySelector('[data-led-slider]');
      const track = section.querySelector('[data-led-track]');
      const slides = section.querySelectorAll('[data-led-slide]');
      const prev = section.querySelector('[data-led-prev]');
      const next = section.querySelector('[data-led-next]');
      const dotsContainer = section.querySelector('[data-led-dots]');

      if (!slider || !track || !slides.length) {
        return;
      }

      section.dataset.ledSliderInitialized = 'true';

      let currentIndex = 0;


      /* =========================
         CREATE DOTS
      ========================= */

      function createDots() {

        if (!dotsContainer) return;

        dotsContainer.innerHTML = '';

        slides.forEach(function (slide, index) {

          const dot = document.createElement('button');

          dot.type = 'button';
          dot.className = 'led-system-26__slider-dot';

          dot.setAttribute(
            'aria-label',
            'Go to image ' + (index + 1)
          );

          if (index === 0) {
            dot.classList.add('is-active');
          }

          dot.addEventListener('click', function () {
            goToSlide(index);
          });

          dotsContainer.appendChild(dot);

        });

      }


      /* =========================
         UPDATE DOTS
      ========================= */

      function updateDots() {

        if (!dotsContainer) return;

        const dots = dotsContainer.querySelectorAll(
          '.led-system-26__slider-dot'
        );

        dots.forEach(function (dot, index) {

          dot.classList.toggle(
            'is-active',
            index === currentIndex
          );

        });

      }


      /* =========================
         GO TO SLIDE
      ========================= */

      function goToSlide(index) {

        if (slides.length <= 1) return;

        if (index < 0) {
          index = slides.length - 1;
        }

        if (index >= slides.length) {
          index = 0;
        }

        currentIndex = index;

        track.style.transform =
          'translate3d(-' + (currentIndex * 100) + '%, 0, 0)';

        updateDots();

      }


      /* =========================
         PREVIOUS
      ========================= */

      if (prev) {

        prev.addEventListener('click', function (event) {

          event.preventDefault();

          goToSlide(currentIndex - 1);

        });

      }


      /* =========================
         NEXT
      ========================= */

      if (next) {

        next.addEventListener('click', function (event) {

          event.preventDefault();

          goToSlide(currentIndex + 1);

        });

      }


      /* =========================
         TOUCH SWIPE
      ========================= */

      let touchStartX = 0;
      let touchEndX = 0;

      track.addEventListener(
        'touchstart',
        function (event) {

          touchStartX =
            event.changedTouches[0].screenX;

        },
        { passive: true }
      );


      track.addEventListener(
        'touchend',
        function (event) {

          touchEndX =
            event.changedTouches[0].screenX;

          const difference =
            touchStartX - touchEndX;

          if (Math.abs(difference) < 40) {
            return;
          }

          if (difference > 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }

        },
        { passive: true }
      );


      /* =========================
         INITIALIZE
      ========================= */

      createDots();

      goToSlide(0);

    }


    /* =========================
       NORMAL SHOPIFY LOAD
    ========================= */

    function initAllLedSliders() {

      document
        .querySelectorAll('.led-system-26')
        .forEach(function (section) {

          initLedSlider(section);

        });

    }


    if (document.readyState === 'loading') {

      document.addEventListener(
        'DOMContentLoaded',
        initAllLedSliders
      );

    } else {

      initAllLedSliders();

    }


    /* =========================
       SHOPIFY THEME EDITOR
    ========================= */

    document.addEventListener(
      'shopify:section:load',
      function (event) {

        const section =
          event.target.querySelector('.led-system-26') ||
          event.target;

        initLedSlider(section);

      }
    );


    document.addEventListener(
      'shopify:section:reorder',
      function () {
        initAllLedSliders();
      }
    );


  })();
